import React from 'react';

const NotesModal = ({ isOpen, notes, onChange, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div
        className="bg-[#343541] rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[80vh] flex flex-col"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Notes</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-1">
          <textarea
            value={notes}
            onChange={e => onChange(e.target.value)}
            className="w-full h-full min-h-[300px] bg-[#23242a] rounded-lg px-4 py-3 text-white border border-gray-700 focus:border-[#19C37D] focus:ring-1 focus:ring-[#19C37D] resize-none"
            placeholder="Add your notes here..."
            autoFocus
          />
        </div>
      </div>
    </div>
  );
};

export { NotesModal };
